import { useCallback, useEffect, useRef, useState } from 'react'

import config, { API_TYPES } from '../constants/app-config'

const azTokenKey = 'WPP_ALPHA_ZULU_TOKEN'

export const useAZToken = (wppToken: string) => {
  const prevWppToken = useRef<string>()
  const [token, setToken] = useState('')

  const setAndSaveToken = useCallback((token: string) => {
    setToken(token)
    localStorage.setItem(azTokenKey, token)
  }, [])

  const fetchAZToken = useCallback(async () => {
    try {
      const res = await fetch(`${config[API_TYPES.BVA_API_URL]}/alpha-zulu/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          client: 'playground-dev-fe',
        },
        body: JSON.stringify({
          token: wppToken,
        }),
      })
      const data = await res.json()
      if (data.accessToken) setAndSaveToken(data.accessToken)
      if (data.error) console.error('Something went wrong with AZ authentication', data.error)
    } catch (error) {
      console.error('Error fetching token', error)
    }
  }, [wppToken, setAndSaveToken])

  const getAZToken = useCallback(() => {
    const tmpToken = localStorage.getItem(azTokenKey) || ''
    if (tmpToken) {
      setToken(tmpToken)
      return
    }
    fetchAZToken()
  }, [fetchAZToken])

  useEffect(() => {
    if (!token && !!wppToken) {
      getAZToken()
      prevWppToken.current = wppToken
      return
    }
    if (prevWppToken.current !== wppToken) {
      fetchAZToken()
      prevWppToken.current = wppToken
    }
  }, [token, wppToken, fetchAZToken, getAZToken])

  const removeToken = () => {
    setToken('')
    localStorage.removeItem(azTokenKey)
  }

  return {
    azAccessToken: token,
    setAndSaveToken,
    removeToken,
    refreshToken: fetchAZToken,
  }
}
